import $ from 'jquery';
import { DRAGGABLE_SCROLL } from './_modules/_draggable_scroll';
import { DETAIL } from './_modules/_detail';
import { LIST } from './_modules/_list';
import { NAV } from './_modules/_nav';

import { PAGE_INDEX } from './_pages/_index';

const COMMON = {
  ready: () => {
    // console.log('common ready');

    // -----------------------------
    // Pages
    // -----------------------------
    switch ($('body').attr('id')) {
      case 'PAGE_INDEX':
        PAGE_INDEX.ready();
        break;
    }

    DRAGGABLE_SCROLL.init();
    DETAIL.init();
    LIST.init();
    NAV.init();
  },
  loaded: () => {
    // console.log('common loaded');

    $('#loading .step1').fadeOut(800, 'swing', function(){
      setTimeout(function(){
        $('#loading').fadeOut(800, 'swing', function(){
          setTimeout(function(){
            $('#map-logo').addClass('loaded');
          }, 200);
        });
      }, 1000);

    });
  }
};

COMMON.ready();
window.addEventListener('load', COMMON.loaded);